import { Button, Form, Input, InputNumber } from 'antd'
import { memo, useCallback } from 'react'
import { Team } from 'types/teams'

type Props = {
    position: Team
    onSubmit: (team: Team) => void
    loading: boolean
}

export const TeamForm = memo((props: Props) => {
    const { position, onSubmit, loading } = props

    const onFinish = useCallback(
        (values: Team) => {
            onSubmit(values)
        },
        [onSubmit]
    )

    return (
        <Form
            name='basic'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete='off'
            disabled={loading}
        >
            <Form.Item
                initialValue={position.name}
                label='Name'
                name='name'
                rules={[{ required: true, message: 'Please input team name!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                initialValue={position.short_name}
                label='Short name'
                name='short_name'
                rules={[
                    { required: true, message: 'Please input team short name!' },
                    {
                        max: 4,
                        message: 'Short name cannot be longer than 4 characters',
                    },
                ]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                initialValue={position.contacts}
                label='Contacts'
                name='contacts'
                rules={[{ required: true, message: 'Please input contact information!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item initialValue={position.instagram ?? undefined} label='Instagram' name='instagram'>
                <Input placeholder='Full link' />
            </Form.Item>

            <Form.Item initialValue={position.telegram ?? undefined} label='Telegram' name='telegram'>
                <Input placeholder='Full link' />
            </Form.Item>

            <Form.Item initialValue={position.logo} label='Logo' name='logo'>
                <Input />
            </Form.Item>

            <Form.Item
                initialValue={position.founded_year ?? undefined}
                label='Founded year'
                name='founded_year'
                rules={[{ type: 'number', min: 1000, max: 9999, message: 'Year must be between 1000 and 9999' }]}
            >
                <InputNumber min={1000} max={9999} placeholder='e.g. 1990' />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
                <Button htmlType={'reset'}>Reset</Button>
            </Form.Item>
        </Form>
    )
})
